import React from 'react';
import { Email, Telefone } from '.';
import { AlunoNome } from '@/Componentes';

export const AlunoCell = ({ aluno }) => {
	return (
		<>
			<AlunoNome value={aluno.nome || ''} />
			<div>
				<small>
					Contatos: <Telefone value={aluno.telefone} /> |{' '}
					<Email value={aluno.email} />
				</small>
			</div>
			<div>
				<small>Curso: {aluno?.curso?.nome || ''}</small>
			</div>
		</>
	);
};
